<template>
  <div style="overflow: hidden">
    <div style="width: 100%; height: 135px; border-bottom: 1px solid #000">
      <!-- 导航栏 -->
      <div style="width: 100%;height:61px;background: #000;">
        <div style="width: 1730px;height: 97px; margin: 0 auto;">
          <Header
            v-if="this.identity !== ''"
            :activeIndex="activeIndex"
            :userName="userName"
            :identity="identity"
            :teacherGroup="teacherGroup"
            :role="role"
          />
        </div>
      </div>
      <!-- 倒计时框 -->
      <div id="textp">{{ countDown }}</div>
    </div>
    <div
      id="cover"
      style="width: 100%;overflow: auto; padding: 15px 5px 8px"
    >
      <el-container>
        <el-main style="padding: 0 0 0 24px">
          <div style="width: 1840px; display: flex; margin: 0 auto;">
            <!-- 内容区域 -->
            <div class="middle_content" style="line-height: 40px">
              <div style="display: flex;">
                <el-button
                  v-if="isSubInfo === 1"
                  style="margin-right: 20px;"
                  type="success"
                  @click="openDialog"
                >
                  查看写作说明
                </el-button>
                <div class="reFrame" v-if="imageList.length > 0">
                  <div style="width: 80px;line-height: 50px;color:#409eff;font-weight: 500;font-size: 16px;">
                    作文原图：
                  </div>
                  <el-image 
                    :src="imageList[0]" 
                    :preview-src-list="imageList"
                    style="width: 50px;height:50px;"
                  >
                  </el-image>
                </div>
              </div>
              <div class="dialog" id="drag">
                <div
                  style="margin: 10px 0; font-size: 25px; text-align: center"
                >
                  写作说明
                </div>
                <div
                  style="
                    position: absolute;
                    top: 10px;
                    right: 20px;
                    width: 30px;
                    height: 30px;
                    font-size: 35px;
                    cursor: default;
                  "
                  @click="closeDialog"
                >
                  <i class="el-icon-close"></i>
                </div>
                <hr style="width: 90%" />
                <div v-if="this.source === 1" class="title_cover">
                  <div
                    v-if="requirements.title && requirements.title !== null"
                    class="requirements"
                  >
                    <div>题目:</div>
                    <div>{{ requirements.title }}</div>
                  </div>
                  <div v-if="requirements.introductions" class="requirements">
                    <div>要求:</div>
                    <div style="word-break: break-word">
                      {{ requirements.introductions }}
                    </div>
                  </div>
                  <div
                    v-if="
                      requirements.pictures && requirements.pictures.length > 0
                    "
                  >
                    <div class="img">附图:</div>
                    <div>
                      <div v-for="(item, i) in requirements.pictures" :key="i">
                        <el-image
                          style="margin-left: 75px; max-width: 500px"
                          :src="item"
                          alt="图片加载失败"
                        >
                        </el-image>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="requirements.starts"
                    class="requirements begin"
                    style="display: flex"
                  >
                    <div>起始句:</div>
                    <div style="word-break: break-word">
                      {{ requirements.starts }}
                    </div>
                  </div>
                  <div
                    v-if="
                      requirements.examples && requirements.examples.length > 0
                    "
                    class="requirements2"
                  >
                    <span>参考范文:</span>
                    <div v-for="(item, i) in requirements.examples" :key="i">
                      <div
                        style="
                          margin: 0 50%;
                          width: 30px;
                          height: 30px;
                          border: 1px solid #666;
                          border-radius: 50%;
                          text-align: center;
                          line-height: 30px;
                          background: #409eff;
                        "
                      >
                        {{ i + 1 }}
                      </div>
                      <div
                        style="
                          word-break: break-word;
                          text-align: justify;
                          font-size: 20px;
                        "
                        v-html="requirements.examples[i]"
                      ></div>
                    </div>
                  </div>
                </div>
                <div v-if="this.source === 2" class="title_cover">
                  <div class="requirements">
                    <div>题目:</div>
                    <div
                      v-if="
                        requirements.custom_title &&
                          requirements.custom_title !== null
                      "
                    >
                      {{ requirements.custom_title }}
                    </div>
                  </div>
                  <div
                    v-if="
                      requirements.custom_title_img &&
                        requirements.custom_title_img !== null
                    "
                  >
                    <el-image
                      style="margin-left: 75px; max-width: 500px"
                      :src="requirements.custom_title_img"
                      alt="图片加载失败"
                    >
                    </el-image>
                  </div>
                  <div class="requirements">
                    <div style="width: 135px">写作指导:</div>
                    <div
                      v-if="
                        requirements.main_idea &&
                          requirements.main_idea !== null
                      "
                    >
                      {{ requirements.main_idea }}
                    </div>
                  </div>
                  <div
                    v-if="
                      requirements.main_idea_img &&
                        requirements.main_idea_img !== null
                    "
                  >
                    <el-image
                      style="margin-left: 75px; max-width: 500px"
                      :src="requirements.main_idea_img"
                      alt="图片加载失败"
                    >
                    </el-image>
                  </div>
                  <div class="requirements">
                    <div>范文:</div>
                    <div v-if="requirements.hint && requirements.hint !== null">
                      {{ requirements.hint }}
                    </div>
                  </div>
                  <div
                    v-if="
                      requirements.hint_img && requirements.hint_img !== null
                    "
                  >
                    <el-image
                      style="margin-left: 75px; max-width: 500px"
                      :src="requirements.hint_img"
                      alt="图片加载失败"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
              <p  class="content">{{essay}}</p>
            </div>
            <!-- 右侧边栏 -->
            <div class="right_border">
              <div class="border_title">
                <span>综合得分</span>
                <el-divider direction="vertical"></el-divider>
                <span class="border_score">{{ score }}分</span>
              </div>
              <div class="border_content">
                <span class="border_details">{{dimension.wordName}}</span>
                <el-rate class="border_star" v-model="starW" disabled></el-rate>
                <p class="border_estimate">{{ textW }}</p>
                <el-divider></el-divider>
                <span class="border_details">{{dimension.sentenceName}}</span>
                <el-rate
                  class="border_star"
                  v-model="starSen"
                  disabled
                ></el-rate>
                <p class="border_estimate">{{ textSen }}</p>
                <el-divider></el-divider>
                <span class="border_details">{{dimension.structureName}}</span>
                <el-rate
                  class="border_star"
                  v-model="starStr"
                  disabled
                ></el-rate>
                <p class="border_estimate">{{ textStr }}</p>
                <el-divider></el-divider>
                <p class="border_title">作文点评</p>
                <p class="border_remark"></p>
                <div v-if="speechFile">
                  <el-divider></el-divider>
                  <div style="font-size: 20px; font-weight: 550; color: #000">
                    语音点评
                  </div>
                  <div style="margin: 0 auto; width: 300px; height: 58px">
                    <audio :src="speechFile" controls></audio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
      <!-- 系统批改详情 -->
      <fieldset class="fieldset">
        <legend style="font-size: 20px; color: #333">系统批改详情</legend>
      </fieldset>
      <el-collapse
        v-model="activeNames"
        @change="handleChange"
        class="collapse"
      >
        <el-collapse-item
          v-for="(item, index) in details"
          :key="index"
          :title="
            '第 ' +
              pids.find((n, index) => index + 1 === item.pid) +
              ' 段 [ ' +
              item.sentences.length +
              ' ]'
          "
          :name="index"
        >
          <div v-for="(item1, index1) in item.sentences" :key="index1">
            <div
              style="
                display: inline-block;
                float: left;
                width: 65%;
                font-size: 20px;
              "
            >
              <span style="font-weight: 600"
                >{{ item1.sentence.gsid }}.&nbsp;&nbsp;
              </span>
              <span v-html="item1.sentenceSolo"></span>
            </div>
            <div
              v-for="(item2, index2) in errList"
              :key="index2"
              style="margin-left: 1300px"
            >
              <ul
                v-if="
                  item2.offset >= item1.sentence.offset &&
                    item2.offset < item1.sentence.offset + item1.sentence.length
                "
                style="word-break: break-all; font-size: 20px"
              >
                <li>
                  <div
                    class="add"
                    v-if="item2.issueType.indexOf('加分项') >= 0"
                  >
                    <span class="tags_badge">{{ index2 + 1 }}</span>
                    <span style="color: #3db95c"
                      >[ {{ item2.issueType }} ]</span
                    >
                  </div>
                  <div v-if="item2.issueType.indexOf('扣分项') >= 0">
                    <span class="tags_badge">{{ index2 + 1 }}</span>
                    <span style="color: #fc500d"
                      >[ {{ item2.issueType }} ]</span
                    >
                  </div>
                  <div
                    class="other_tags"
                    v-if="item2.issueType.indexOf('其他项') >= 0"
                  >
                    <span class="tags_badge">{{ index2 + 1 }}</span>
                    <span style="color: #5e79fd"
                      >[ {{ item2.issueType }} ]</span
                    >
                  </div>
                </li>
                <li style="margin-left: 27px; display: flex">
                  <div style="width: 120px">标注词句：</div>
                  <div style="width: 370px">
                    {{ essay1.substr(item2.offset, item2.length) }}
                  </div>
                </li>
                <li style="margin-left: 27px; display: flex">
                  <div style="width: 120px">批改说明：</div>
                  <div style="width: 370px">{{ item2.message }}</div>
                </li>
                <li></li>
              </ul>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <fieldset class="fieldset">
        <legend style="font-size: 20px; color: #333">审核结果</legend>
      </fieldset>
      <div style="width: 1840px;margin: 0 auto;">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          style="margin: 20px 0"
        >
          <div style="width: 500px; margin: 0 0 10px 65px">
            <el-radio v-model="radio" label="0" border @change="radioChange"
              >通过</el-radio
            >
            <el-radio v-model="radio" label="1" border @change="radioChange"
              >不通过</el-radio
            >
            <el-button
              v-if="btnNum === 0"
              type="info"
              style="width: 140px; font-size: 20px; margin-left: 10px"
              >提 交({{ this.delayed }}秒)</el-button
            >
            <el-button
              v-if="btnNum === 1"
              type="primary"
              @click="submitForm()"
              style="width: 140px; font-size: 20px; margin-left: 10px"
              >提 交</el-button
            >
          </div>
          <el-dialog
            width="30%"
            title="温馨提示"
            :visible.sync="innerVisible"
            append-to-body
            top="35vh"
          >
            <div style="margin-left: 20px; font-size: 15px">确认提交审核？</div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handleTwoClose()">取消</el-button>
              <el-button type="primary" @click="handleTwoTo()"
                >确认提交</el-button
              >
            </span>
          </el-dialog>
          <el-form-item prop="textarea" v-if="radio === '1'">
            <el-input
              type="textarea"
              resize="none"
              v-model="ruleForm.textarea"
              class="notpassing"
              maxlength="2000"
              placeholder="请输入审核不通过原因(最少输入10个字符)"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
import $ from "jquery";
import axios from "axios";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
import Header from "./header.vue";
export default {
  data() {
    return {
      role: 2,
      activeIndex: "myTasks",
      userName: "张三",
      identity: "",
      teacherGroup: 0,
      countDown: "",
      allTime: 0,
      timenow: "",
      deadline: "",
      pids: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
      options: [
        { value: "whitespace", label: "空白提示" },
        { value: "grammar", label: "语法错误" },
        { value: "style", label: "句子冗长" },
        { value: "misspelling", label: "拼写错误" },
        { value: "typographical", label: "排版问题" },
        { value: "duplication", label: "重复提示" },
        { value: "locale-violation", label: "美式英语" },
        { value: "inconsistency", label: "搭配不当" },
        { value: "uncategorized", label: "未分类处" }
      ],
      value: "",
      texts: {},
      index: 1,
      ruleForm: {
        textarea: ""
      },
      rules: {
        textarea: [
          {
            required: true,
            message: "请输入审核不通过原因",
            trigger: "change"
          },
          { max: 500, message: "500个字符以内" }
        ]
      },
      radio: "0",
      resultcode: 0,
      score: 0,
      starW: 0,
      starSen: 0,
      starStr: 0,
      textW: "",
      textSen: "",
      textStr: "",
      summary: "",
      speechFile: "",
      dataNew: [],
      essay: "",
      essay1: "",
      details: [],
      activeNames: [],
      id: 0, //接收页面跳转传过来的值
      mode: 2,
      delayed: 10, //提交按钮延时
      btnNum: 1, //0代表有10秒倒计时，1代表无倒计时
      innerVisible: false,
      errList: [],
      isSubInfo: 0, // 是否显示查看写作要求的按钮 1---true  0---false
      requirements: {
        // 作文写作要求
        // source为1时
        title: "",
        introductions: "",
        pictures: [],
        starts: "",
        examples: [],
        // source为2时
        custom_title: "", // 题干文本内容
        custom_title_img: "", // 题干图片地址
        main_idea: "", // 写作指导文本内容
        main_idea_img: "", // 写作指导图片地址
        hint: "", // 写作范文文本内容
        hint_img: "" // 写作范文图片地址
      },
      source: 1, // 表示写作要求的来源，可选值为1和2
      imageList: [],  // 作文原图的列表
      degrees: 0,
      grade: 7,
      dimension: {
        wordName: '词汇运用',
        sentenceName: '语言表达',
        structureName: '篇章结构'
      }
    };
  },
  components: {
    Header
  },
  mounted() {
    this.directive();
    this.init();
  },
  methods: {
    // 页面初始化接口
    init() {
      if (localStorage.getItem("token")) {
        this.role = Number(localStorage.getItem("role"));
        let token = jwt_decode(localStorage.getItem("token"));
        // 获取用户信息（用户名和用户身份）
        this.identity = token.identity;
        this.teacherGroup = token.teacher_group;
        this.userName = token.nickname;
        this.id = this.$route.query.id;
        this.mode = this.$route.query.mode;
        // 判断是从哪个页面跳转过来的，渲染提交按钮时是否带倒计时
        if (Number(this.mode) === 1) {
          this.btnNum = 1;
        }
        if (Number(this.mode) === 0) {
          this.btnNum = 0;
        }
        home
          .taskReview({ taskid: this.id, mode: 2 })
          .then(res => {
            if (res.data.retcode === 0) {
              this.dataNew = res.data.data;
              this.timenow = res.data.data.timenow;
              this.deadline = res.data.data.deadline;
              this.essay = res.data.data.essay;
              this.essay1 = res.data.data.essay;
              // 获取年级信息
              this.grade = res.data.data.grade;
              // 根据年级信息定义三个维度
              if (this.grade > 9) {
                if (res.data.data.subject_info) {
                  const type = res.data.data.subject_info.sub_type;
                  if (type === 12702) {// 概要写作
                    this.dimension.wordName = '要点';
                    this.dimension.sentenceName = '语言';
                    this.dimension.structureName = '连贯性';
                  } else if (type === 12703) { // 读后续写
                    this.dimension.wordName = '语言';
                    this.dimension.sentenceName = '内容';
                    this.dimension.structureName = '连贯性';
                  } else {
                    this.dimension.wordName = '语言';
                    this.dimension.sentenceName = '内容';
                    this.dimension.structureName = '结构';
                  }
                } else {
                  this.dimension.wordName = '语言';
                  this.dimension.sentenceName = '内容';
                  this.dimension.structureName = '结构';

                }
              };
              this.details = JSON.parse(res.data.data.details);
              this.score = res.data.data.score;
              this.starW = JSON.parse(res.data.data.comments).word.star / 2;
              this.textW = JSON.parse(res.data.data.comments).word.text;
              this.starSen =
                JSON.parse(res.data.data.comments).sentence.star / 2;
              this.textSen = JSON.parse(res.data.data.comments).sentence.text;
              this.starStr =
                JSON.parse(res.data.data.comments).structure.star / 2;
              this.textStr = JSON.parse(res.data.data.comments).structure.text;
              this.summary = JSON.parse(res.data.data.comments).summary;
              if(res.data.data.images){
                this.imageList = res.data.data.images;
              }
              // 获取作文试题信息
              if (res.data.data.subject_info) {
                this.isSubInfo = 1;
                this.source = res.data.data.subject_info.source;
                if (this.source === 1) {
                  this.requirements.title = res.data.data.subject_info.title;
                  this.requirements.introductions =
                    res.data.data.subject_info.introductions;
                  this.requirements.starts = res.data.data.subject_info.starts;
                  this.requirements.examples =
                    res.data.data.subject_info.examples;
                  this.requirements.pictures =
                    res.data.data.subject_info.pictures;
                } else {
                  this.requirements.custom_title =
                    res.data.data.subject_info.custom_title;
                  this.requirements.custom_title_img =
                    res.data.data.subject_info.custom_title_img;
                  this.requirements.main_idea =
                    res.data.data.subject_info.main_idea;
                  this.requirements.main_idea_img =
                    res.data.data.subject_info.main_idea_img;
                  this.requirements.hint = res.data.data.subject_info.hint;
                  this.requirements.hint_img =
                    res.data.data.subject_info.hint_img;
                }
              }
              // 遍历错误塞进数组
              for (let i = 0; i < this.details.length; i++) {
                for (let j = 0; j < this.details[i].sentences.length; j++) {
                  for (
                    let z = 0;
                    z < this.details[i].sentences[j].questions.length;
                    z++
                  ) {
                    let item = this.details[i].sentences[j].questions[z];
                    this.errList.push(item);
                  }
                }
              }
              $(".border_remark")[0].innerHTML = this.summary.replace(
                /\n/g,
                "<br>"
              );
              // 有语音文件时才显示语音点评部分,无语音点评部分，增加作文点评显示的范围
              if (res.data.data.speechFile) {
                this.speechFile = res.data.data.speechFile;
              } else {
                $(".border_remark")[0].style.height = "175px";
              }
              for (let i = 0; i < this.details.length; i++) {
                this.activeNames.push(i);
              }
              this.timeDown(); //页面一加载显示倒计时框
              this.errorTagging(this.dataNew); //页面一加载显示所有错误标注
            } else if (res.data.retcode === 1 || res.data.retcode === 2) {
              this.$alert(res.data.retmsg, "登录异常", {
                confirmButtonText: "确定",
                callback: action => {
                  this.clearCache();
                }
              });
            } else {
              this.$alert(res.data.retmsg, "请求失败", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        setTimeout(() => {
          alert("未登录，请重新登录");
          this.$router.push({ path: "/login" });
        }, 500);
      }
    },
    // 倒计时
    timeDown() {
      //获得审核时限
      this.allTime = Date.parse(this.deadline) - Date.parse(this.timenow);
      if (this.allTime > 0) {
        let t1 = setInterval(() => {
          let day = Math.floor(this.allTime / (24 * 60 * 60 * 1000));
          let hour = Math.floor(
            (this.allTime - day * 24 * 60 * 60 * 1000) / (60 * 60 * 1000)
          );
          let minute = Math.floor(
            (this.allTime - day * 24 * 60 * 60 * 1000 - hour * 60 * 60 * 1000) /
              (60 * 1000)
          );
          let second = Math.floor(
            (this.allTime -
              day * 24 * 60 * 60 * 1000 -
              hour * 60 * 60 * 1000 -
              minute * 60 * 1000) /
              1000
          );
          hour = day * 24 + hour;
          if (hour < 10) {
            hour = "0" + hour;
          }
          if (minute < 10) {
            minute = "0" + minute;
          }
          if (second < 10) {
            second = "0" + second;
          }
          this.countDown = "剩余时间 " + hour + " : " + minute + " : " + second;
          this.allTime -= 1000;
          // 倒计时归零时清楚定时器
          if (this.allTime === 0) {
            clearInterval(t1);
            this.countDown = "任务已超时，请及时处理";
          }
        }, 1000);
      } else {
        this.countDown = "任务已超时，请及时处理";
      }
      let t2 = setInterval(() => {
        this.delayed -= 1;
        if (this.delayed === 0) {
          this.btnNum = 1;
          clearInterval(t2);
        }
      }, 1000);
    },
    //遍历错误单词标注
    errorTagging(data) {
      let html = data.essay;
      let details = JSON.parse(data.details);
      for (let i = details.length - 1; i >= 0; i--) {
        for (let j = details[i].sentences.length - 1; j >= 0; j--) {
          //错误详情展示下的每个独立句子
          details[i].sentences[j].sentenceSolo = data.essay.substr(
            details[i].sentences[j].sentence.offset,
            details[i].sentences[j].sentence.length
          );
          for (
            let z = details[i].sentences[j].questions.length - 1;
            z >= 0;
            z--
          ) {
            //错误详情展示下的错误词句
            details[i].sentences[j].questions[z].errorSolo = data.essay.substr(
              details[i].sentences[j].questions[z].offset,
              details[i].sentences[j].questions[z].length
            );
            details[i].sentences[j].sentenceSolo1 = details[i].sentences[
              j
            ].sentenceSolo.split("");
            if (
              details[i].sentences[j].questions[z].issueType.indexOf(
                "加分项"
              ) >= 0
            ) {
              details[i].sentences[j].sentenceSolo1.splice(
                details[i].sentences[j].questions[z].offset -
                  details[i].sentences[j].sentence.offset,
                details[i].sentences[j].questions[z].length,
                '<errorWords class="errWord1"><xmp style="display:inline-block;margin:0;">' +
                  details[i].sentences[j].questions[z].errorSolo +
                  "</xmp></errorWords>"
              );
            } else if (
              details[i].sentences[j].questions[z].issueType.indexOf(
                "扣分项"
              ) >= 0
            ) {
              details[i].sentences[j].sentenceSolo1.splice(
                details[i].sentences[j].questions[z].offset -
                  details[i].sentences[j].sentence.offset,
                details[i].sentences[j].questions[z].length,
                '<errorWords class="errWord2"><xmp style="display:inline-block;margin:0;">' +
                  details[i].sentences[j].questions[z].errorSolo +
                  "</xmp></errorWords>"
              );
            } else {
              details[i].sentences[j].sentenceSolo1.splice(
                details[i].sentences[j].questions[z].offset -
                  details[i].sentences[j].sentence.offset,
                details[i].sentences[j].questions[z].length,
                '<errorWords class="errWord3"><xmp style="display:inline-block;margin:0;">' +
                  details[i].sentences[j].questions[z].errorSolo +
                  "</xmp></errorWords>"
              );
            }
            details[i].sentences[j].sentenceSolo = details[i].sentences[
              j
            ].sentenceSolo1.join("");
          }
        }
      }
      this.details = JSON.parse(JSON.stringify(details));
      // this.essay = html.replace(/\n/g, "<br>");
    },
    handleChange(val) {
      // 
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
    //提交按钮
    submitForm() {
      if (this.radio === "0") {
        this.innerVisible = true;
      }
      if (this.radio === "1") {
        if (this.ruleForm.textarea && this.ruleForm.textarea.length >= 10) {
          this.innerVisible = true;
        } else if (
          this.ruleForm.textarea &&
          this.ruleForm.textarea.length < 10
        ) {
          this.$alert("最少输入10个字符，请确认", "温馨提示", {
            confirmButtonText: "确定",
            closeOnClickModal: true,
            callback: res => {}
          });
        } else {
          this.$alert("请输入审核不通过的原因", "温馨提示", {
            confirmButtonText: "确定",
            closeOnClickModal: true,
            callback: res => {}
          });
        }
      }
    },
    // 提交接口
    handleTwoTo() {
      let data = {
        taskid: this.id,
        resultcode: Number(this.radio),
        description: this.ruleForm.textarea
      };
      home
        .taskSubmit(data)
        .then(res => {
          this.innerVisible = false;
          if (res.data.retcode === 0) {
            this.$message({
              message: res.data.retmsg,
              type: "success",
              duration: 2000,
              onClose: res => {
                this.$router.push({ path: "myTasks" });
              }
            });
          } else if (res.data.retcode === 1 || res.data.retcode === 2) {
            this.$alert(res.data.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: action => {
                this.clearCache();
              }
            });
          } else {
            this.$alert(res.data.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(err => {
          console.log(222, err);
        });
    },
    //取消按钮
    handleTwoClose() {
      this.innerVisible = false;
    },
    radioChange(val) {
      if (val === "1") {
        // 设置页面滚动条滚动到页面最底部
        $("#cover").scrollTop(10000);
      }
    },
    // 自定义弹框拖拽函数
    directive() {
      let drag = $("#drag")[0];
      // //点击某物体时，用drag对象即可，move和up是全局区域，
      // 也就是整个文档通用，应该使用document对象而不是drag对象(否则，采用drag对象时物体只能往右方或下方移动)
      drag.onmousedown = function(event) {
        var event = event || window.event; //兼容IE浏览器
        //    鼠标点击物体那一刻相对于物体左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
        var diffX = event.clientX - drag.offsetLeft;
        var diffY = event.clientY - drag.offsetTop;
        if (typeof drag.setCapture !== "undefined") {
          drag.setCapture();
        }
        document.onmousemove = function(event) {
          var event = event || window.event;
          var moveX = event.clientX - diffX;
          var moveY = event.clientY - diffY;
          if (moveX < 0) {
            moveX = 0;
          } else if (moveX > window.innerWidth - drag.offsetWidth) {
            moveX = window.innerWidth - drag.offsetWidth;
          }
          if (moveY < 0) {
            moveY = 0;
          } else if (moveY > window.innerHeight - drag.offsetHeight) {
            moveY = window.innerHeight - drag.offsetHeight;
          }
          drag.style.left = moveX + "px";
          drag.style.top = moveY + "px";
        };
        document.onmouseup = function(event) {
          this.onmousemove = null;
          this.onmouseup = null;
          //修复低版本ie bug
          if (typeof drag.releaseCapture != "undefined") {
            drag.releaseCapture();
          }
        };
      };
    },
    // '查看写作说明'按钮的回调
    openDialog() {
      $("#drag")[0].style.display = "inline";
    },
    // 关闭写作要求模态框的回调
    closeDialog() {
      // 关闭对话框前先将滚动条移动到默认的起始位置
      $(".title_cover").scrollTop(0);
      $("#drag")[0].style.display = "none";
    },
  }
};
</script>
<style scoped>
/* 倒计时 */
#textp {
  margin: 10px auto;
  width: 500px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #f56c6c;
  font-size: 25px;
  text-align: center;
  background: #fff;
  font-weight: 700;
  letter-spacing: 2px;
}
/* 作文内容 */
.content {
  line-height: 40px;
  font-size: 25px;
  white-space: pre-wrap;
}
.middle_content {
  /* display: none; */
  display: inline-block;
  border: 1px solid #9c9898;
  padding: 15px 10px 15px 25px;
  height: 600px;
  width: 1200px;
  overflow-y: scroll;
}
/* 右侧得分 */
.right_border {
  /* float: right; */
  border: 1px solid #9c9898;
  padding: 20px;
  height: 590px;
  width: 520px;
  margin: 0 20px;
}
.border_title {
  margin: 0;
  font-size: 20px;
  font-weight: 550;
  color: #000;
}
.border_remark {
  margin: 0 0 10px 0;
  width: 476px;
  height: 70px;
  line-height: 20px;
  font-size: 16px;
  overflow: auto;
  word-wrap: break-word;
  text-align: justify;
}
.el-divider--vertical {
  width: 2px !important;
}
.el-divider--horizontal {
  margin: 0 0 5px !important;
}
.border_score {
  color: #ff9800;
}
.border_content {
  font-size: 15px;
  margin-top: 10px;
  color: #58595a;
}
.border_content p {
  margin-top: 10px;
}
.border_estimate {
  /* 溢出隐藏，显示三个省略号 */
  /* overflow: hidden;
        text-overflow: ellipsis; */
  margin: 5px 0;
  overflow: auto;
  word-wrap: break-word;
  width: 476px;
  height: 55px;
}
.border_star {
  display: inline-block;
  margin-left: 274px;
}
.border_details {
  color: #00bcd4;
  font-size: 16px;
}

ul li {
  list-style: none;
}
a {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
/* --------------------------------------- */
/* 详情列表 */

.el-collapse {
  width: 1840px;
  letter-spacing: 0.5px;
  margin: 0 auto;
}
.el-collapse-item__content > div {
  border-bottom: 1px solid #e4e4e4;
  padding: 10px;
  font-size: 14px;
  overflow: auto;
}
.tags_badge {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  font-size: 12px;
  color: #fff;
  background: #fc500d;
}
.add .tags_badge {
  background: #3db95c;
}
.other_tags .tags_badge {
  background: #5e79fd;
}
.requirements {
  margin-bottom: 10px;
  font-size: 20px;
  display: flex;
}
.requirements span,
.requirements2 span,
.requirements div:first-child,
.img {
  font-size: 25px;
  /* font-weight:bolder; */
  color: #000;
}
.requirements div:first-child {
  width: 75px;
}
.requirements div:nth-child(2) {
  width: 665px;
}
.begin div:first-child {
  width: 95px;
}
.begin div:nth-child(2) {
  width: 645px;
}
.requirements2 > div div:nth-child(2) p {
  font-size: 20px;
}
.dialog {
  position: absolute;
  width: 800px;
  height: 400px;
  border: 1px solid #333;
  cursor: move;
  display: none;
  border-radius: 25px;
  /* background: rgba(84, 88, 68, 0.1); */
  background: #fff;
  z-index: 2;
}
.title_cover {
  width: 95%;
  height: 320px;
  margin: 0px auto 50px;
  padding-right: 15px;
  overflow: auto;
}
.fieldset {
  width: 1840px;
  border: 0; 
  border-top: 1px solid #999; 
  margin: 50px auto 0;
}
.reFrame {
  display: flex;
}

</style>
<style>
/* 审核结果 */
textarea::-webkit-input-placeholder {
  font-family: Arial;
} /* 使用webkit内核的浏览器 */
textarea:-moz-placeholder {
  font-family: Arial;
} /* Firefox版本4-18 */
textarea::-moz-placeholder {
  font-family: Arial;
} /* Firefox版本19+ */
textarea:-ms-input-placeholder {
  font-family: Arial;
} /* IE浏览器 */
/* .el-form-item__content {
        margin-left: 0 !important;
        margin-top: 20px;
    } */
.notpassing textarea {
  height: 200px;
  margin-left: -36px;
  line-height: 30px;
  font-size: 20px;
}
.collapse .el-collapse-item__header {
  background: #6cb3fd !important;
  height: 43px !important;
  opacity: 0.8;
  color: #fff !important;
  padding-left: 10px;
  font-size: 16px;
}
.collapse .el-collapse-item__wrap {
  border-bottom: none !important;
}
.errWord1 {
  color: #3db95c;
}
.errWord2 {
  color: #fc500d;
}
.errWord3 {
  color: #5e79fd;
}
/*控制图片放大后的遮罩层的显示范围  */
.reFrame .el-image-viewer__wrapper {
  width: 60%;
  margin: 0 20%;
}
/* 控制图片放大后的遮罩层大小 */
.reFrame .el-image-viewer__mask { 
  width: 0;
}
/* 控制图片放大后的遮罩层关闭按钮的颜色和位置 */
.reFrame .el-image-viewer__close {
  top: 80px;
  color: #409eff;
}
</style>
